module.exports = __webpack_public_path__ + "static/img/3.f1a9bd3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guangdong/3.jpg
// module id = 9cfx
// module chunks = 1